import type { User } from '@/types/user';

/**
 * Email del superadmin (acceso completo)
 */
export const SUPERADMIN_EMAIL = 'enriquemondejar15@gmail.com';

/**
 * Verifica si un usuario es superadmin basado en su email
 */
export function isSuperAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase() === SUPERADMIN_EMAIL.toLowerCase();
}

/**
 * Verifica si un usuario es admin (role = 'admin')
 */
export function isAdmin(user: User | null | undefined): boolean {
  if (!user) return false;
  return user.role === 'admin';
}

/**
 * Verifica si un usuario tiene acceso de administración
 * (es admin o superadmin)
 */
export function hasAdminAccess(user: User | null | undefined): boolean {
  if (!user) return false;
  return isAdmin(user) || isSuperAdmin(user.email);
}

/**
 * Verifica si un usuario tiene acceso de superadmin
 * (solo el superadmin tiene este acceso)
 */
export function hasSuperAdminAccess(user: User | null | undefined): boolean {
  if (!user) return false;
  return isSuperAdmin(user.email);
}

/**
 * Alias de hasSuperAdminAccess para uso semántico como "rol"
 */
export function hasSuperAdminRole(user: User | null | undefined): boolean {
  return hasSuperAdminAccess(user);
}
